import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Product.Delete.IRequest;
type Response = Api.Core.Product.Delete.IResponse;
type Headers = Api.Core.Product.Delete.IHeaders;
const url = '/api/ProductManagement/Product/:id/Clone';
export default async function productCloneApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
